import { Pipe, PipeTransform } from '@angular/core';

import { ISalesOrder } from 'v2/modules/order/interfaces/order.interface';

import { ESalesOrderStatusValue } from '../interfaces/sales-order.interface';

@Pipe({
  name: 'canEditSalesOrder',
  standalone: true,
})
export class CanEditSalesOrderPipe implements PipeTransform {
  transform(salesOrder :ISalesOrder) :boolean {
    const nonEditableStatuses = [
      ESalesOrderStatusValue.SHIPPED,
      ESalesOrderStatusValue.CANCELLED,
      ESalesOrderStatusValue.AWAITING_SHIPMENT,
    ];

    return !nonEditableStatuses.includes(
      salesOrder?.orderStatus as ESalesOrderStatusValue,
    );
  }
}
